import { jsx as _jsx } from "react/jsx-runtime";
import { Alert, Snackbar } from "@mui/material";
export const ErrorConnectionComponent = ({ errorConnection, closeErrorConnection }) => {
    const onClose = () => {
        if (closeErrorConnection)
            closeErrorConnection();
    };
    return (_jsx(Snackbar, { open: errorConnection, autoHideDuration: 6000, onClose: onClose, children: _jsx(Alert, { onClose: closeErrorConnection, severity: 'error', variant: "filled", sx: { width: '100%' }, children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435." }) }));
};
